import { makeStyles } from '@mui/styles';

export default makeStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.down('sm')]: {
      minHeight: '70vh',
    },
  },
  content: {
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  picture: {
    maxWidth: '100%',
  },
}));
